
import {React, useState, useEffect} from 'react';
import Dropdown from '../Components/Dropdown';
import {fetchData, PostData} from '../Services/httpHandelars'
import { useGlobalContext } from '../context'
import Snackbar from '../Components/Snackbar';
import Loader from '../Components/Loader';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
 
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ViolationCard from '../Components/ViolationCard';
import { Types_Enums,
  One_Two_S_Rule,
  Two_Two_S_Rule,
  One_Three_S_Rule,
  R_Four_S_Rule,
  Four_One_S_Rule,
  Ten_X_Rule
 } from '../Services/violationFunctions';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  
  Tooltip,
  Legend
);

 const optionControl = {
  type: 'line',
  options: {
      elements: {
          point:{
              radius: 0
          }
      }
  }
}




export default function Chart() {
  const {setLoading, loading} = useGlobalContext();

  const [form, setForm] = useState({startDate:"", endDate:"", controlName:"", analyzerName:""})
  const [snacBar, setSnacBar ] =useState({snacStatus: false, message:"", snackType:""})
  const [Control, setControlName] = useState([]);
  const [ControlData, setControlData] = useState([]);
  const [AnalyzerName, setAnalyzerName] = useState([]);
  const [showCard, setShowCard] = useState(false)
  const [chartData, setChartData] = useState()
  const [violationData, setViolationData] = useState([])
  // const [option, SetOption] = useState(true)

  useEffect(
    () => {
      if(snacBar.snacStatus === true){
        console.log(snacBar.snacStatus)
        setTimeout(() => setSnacBar(false), 2000);
      }
    },
    
    [snacBar.snacStatus]
  );

  useEffect(() => {
    fetchData("/api/getControlSetup").then((data) => {
      data = JSON.parse(data);
      const control = (data.data);
      const Name = control.map(name=>name?.ControlName)
      // const _id = control.map(name=>name._id)
      setControlData(control)
      setControlName(Name)
      // console.log(80, control)
    }).catch(e => console.log(e));

    fetchData("/api/getAnalyzerSetup").then((data) => {
      data = JSON.parse(data);
      const Analyzer = (data.data);
      const Name = Analyzer.map(name=>name?.AnalyzerName)
      setAnalyzerName(Name)
    }).catch(e => console.log(e));

  },[])



  const options =["one","Two","Three","Four"]

  const handleChange = (e) =>{
    setForm({...form, [e.target.name]: e.target.value})
  }
  const handleCards = () =>{
    setShowCard(!showCard)
  }
  
  const handleSearch = () => {
    setChartData();
    setLoading(true)
    console.log(showCard)
    if(form.startDate && form.endDate && form.controlName && form.analyzerName){
      const Controller = ControlData.find((name)=>(name.ControlName===form.controlName))
console.log(Controller._id,"crl")
      const data = {
          startDate: form.startDate,
          endDate: form.endDate,
          controlName: form.controlName,
          analyzerName: form.analyzerName,
          _id:Controller._id
      }

      PostData ("/api/getControlGraphData", data ).then((data)=>{
        setLoading(false)
        if(data.status === true){
          setSnacBar({...snacBar, 
            snacStatus: data.status,
            message:data.message,
            snackType:"Success"
          })

          const labels = []
          const data_values = []
          const std_line = []
          const std_line_2 = []
          const std_line_3 = []
          const neg_std_line_1 = []
          const neg_std_line_2 = []
          const neg_std_line_3 = []
          const Mean_Value = []
          
          let labelIndex = ""
          // setResults(data)
          data.ResultData.forEach(( value,index) => {
            labelIndex = String(index+1)
            labels.push(labelIndex)
            data_values.push(value.Result)
            std_line.push(data.meanValue + data.standardDeviationValue)
            std_line_2.push(data.meanValue + data.standardDeviationValue * 2)
            std_line_3.push(data.meanValue + data.standardDeviationValue * 3)
            neg_std_line_1.push(data.meanValue - data.standardDeviationValue)
            neg_std_line_2.push(data.meanValue - data.standardDeviationValue * 2)
            neg_std_line_3.push(data.meanValue - data.standardDeviationValue * 3)
            Mean_Value.push(data.meanValue)
          });
          let violationData = [];
          violationData.push({violationName: Types_Enums.ONE_TWO_S_RULE, Count: One_Two_S_Rule(data.ResultData, data.standardDeviationValue, data.meanValue)})
          violationData.push({violationName: Types_Enums.TWO_TWO_S_RULE, Count: Two_Two_S_Rule(data.ResultData, data.standardDeviationValue, data.meanValue)})
          violationData.push({violationName: Types_Enums.ONE_THREE_S_RULE, Count: One_Three_S_Rule(data.ResultData, data.standardDeviationValue, data.meanValue)})
          violationData.push({violationName: Types_Enums.R_FOUR_S_RULE, Count: R_Four_S_Rule(data.ResultData, data.standardDeviationValue, data.meanValue)})
          violationData.push({violationName: Types_Enums.FOUR_ONE_S_RULE, Count: Four_One_S_Rule(data.ResultData, data.standardDeviationValue, data.meanValue)})
          violationData.push({violationName: Types_Enums.TEN_X_RULE, Count: Ten_X_Rule(data.ResultData, data.standardDeviationValue, data.meanValue)})
          console.log("violationData ---> ",violationData);
          setViolationData(violationData);
          //checkForViolationRules(data.ResultData, data.standardDeviationValue)
          const datasetObj = {
            label: form.controlName,
            data: data_values,
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          }
          const one_std_line = {
            label: '+STD 1',
            data: std_line,
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
            elements: {
                  point:{
                      radius: 0
                  }
              }
          
          }
          const mean_value_line = {
            label: 'Mean',
            data: Mean_Value,
            borderColor: 'rgb(128,128,128)',
            backgroundColor: 'rgba(128,128,128, 0.5)',
            elements: {
                  point:{
                      radius: 0
                  }
              }
          }
          const two_std_line = {
            label: '+STD 2',
            data: std_line_2,
            borderColor: 'rgb(0, 255, 0)',
            backgroundColor: 'rgba(0, 255, 0, 0.5)',
            elements: {
              point:{
                  radius: 0
              }
            }
          }
          const three_std_line = {
            label: '+STD 3',
            data: std_line_3,
            borderColor: 'rgb(255,165,0)',
            backgroundColor: 'rgb(255,165,0, 0.5)',
            elements: {
              point:{
                  radius: 0
              }
            }
          }
          const neg_one_std_line = {
            label: '-STD 1',
            data: neg_std_line_1,
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
            elements: {
              point:{
                  radius: 0
              }
          }
          }
          const neg_two_std_line = {
            label: '-STD 2',
            data: neg_std_line_2,
            borderColor: 'rgb(0, 255, 0)',
            backgroundColor: 'rgba(0, 255, 0, 0.5)',
            elements: {
              point:{
                  radius: 0
              }
            }
          }
          const neg_three_std_line = {
            label: '-STD 3',
            data: neg_std_line_3,
            borderColor: 'rgb(255,165,0)',
            backgroundColor: 'rgb(255,165,0, 0.5)',
            elements: {
              point:{
                  radius: 0
              }
            }
          }
          let dataset = [];
          dataset.push(datasetObj,mean_value_line,one_std_line,two_std_line,three_std_line,neg_one_std_line,neg_two_std_line,neg_three_std_line)
          // dataset.push(one_std_line)
          // dataset.push(two_std_line)

          let a = {
            labels,
            datasets: dataset
          }
          setChartData(a);
        } 
      }, (err) => {
        setLoading(false)
        setSnacBar({...snacBar, 
          snacStatus: true,
          message: err,
          snackType:"Error"
        })
      })
    }
    else{
        setLoading(false)
        setSnacBar({...snacBar, 
          snacStatus: true,
          message:"Please Enter values to search",
          snackType:"warning"
        })

      }
  }

  function checkForViolationRules(resultData, SDValue)  {
    console.log("228 ---> ", resultData)
    console.log("229 ---> ", SDValue)
    console.log("230 ---> ", -SDValue * 2)
    console.log("231 ---> ", SDValue * 2)
    let violationCount = {};
    let violationData = [];
    for(let i = 0; i < resultData.length-1; i++){
      if(resultData[i].Result > (SDValue * 3) || resultData[i].Result < (-SDValue * 3)) {
        if(violationCount["1-3s Rule"]){
          violationCount["1-3s Rule"]++;
        }
        else{
          violationCount["1-3s Rule"] = 1;
        }
      }
      else{
        if(resultData[i].Result > (SDValue * 2) || resultData[i].Result < (-SDValue * 2)) {
          if(resultData[i + 1].Result > (SDValue * 2) || resultData[i + 1].Result < (-SDValue * 2)){
            //violationData.push({violatioName: "2 Two S Rule", Status: true})
            console.log("264 --> ",resultData[i].Result)
            console.log("265 --> ",resultData[i + 1].Result)
            if(violationCount["2-2s Rule"]){
              violationCount["2-2s Rule"]++;
            }
            else{
              violationCount["2-2s Rule"] = 1;
            }
            
          }
          else {
            //violationData.push({violatioName: "1 Two S Rule", Status: true})
            if(violationCount["1-2s Rule"]){
              violationCount["1-2s Rule"]++;
            }
            else{
              violationCount["1-2s Rule"] = 1;
            }
          }
        }
      }
    }
    console.log("violationCount ---> ",violationCount);
    Object.keys(violationCount).map((key) => {
      violationData.push({violationName: key, Count: violationCount[key]})
    })
    setViolationData(violationData)
  }
  

  return (
    <>
    {!loading ? 
    <div className = "flex flex-col justify-center items-center mt-12">
        <div className='w-3/5'>
       

            <div className="flex justify-center ">
            <h1 className="text-4xl text-center font-medium leading-6 text-gray-900 ">L J Chart</h1>
            </div>

            <div  className="flex items-center mt-8" >
              <div >  
                <label> Start Date</label>           
                <input  value={form?.startDate} onChange={handleChange} name="startDate" type="date" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date start"/>
              </div>
              <span className="mx-4 mt-4 text-gray-500">to</span>
              <div >
                <label>End Date</label>
                <input name="endDate" value={form?.endDate} type="date" onChange={handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date end"/>
            </div>
            <div className='mt-8 ml-4'>
            <Dropdown title={"Control Name"}  options={Control} value={form.controlName} name={"controlName"} handleChange={handleChange}/>
            </div>  
            <div className='mt-8 ml-4 '  >
              <Dropdown title={"Analyzer Name"} options={AnalyzerName} value={form.analyzerName} name={"analyzerName"} handleChange={handleChange}/>
            </div>
            <div className='mt-4 ml-4'>
              <button
                  onClick={handleSearch}
                  className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
              >
                  Search
              </button>            
            </div>
         </div>
         <label for="checked-toggle" class="inline-flex relative items-center cursor-pointer">
  <input onClick={handleCards} checked={showCard?true:false} type="checkbox" value={showCard} id="checked-toggle" class="sr-only peer"/>
  <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
  <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">On/Off</span>
</label>
{showCard &&
       <ViolationCard violationData={violationData}/>
}
{chartData?.datasets.length &&

            <div className='mt-8'>
            <Line options={options} data={chartData} />
            </div>
}
        </div>
        { snacBar?.snacStatus &&
              
              <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
            } 
    </div >
    : <Loader />} 
    </>
  )
}


